<script>
import UsersTransferReceiptListVue from '@/app/users/components/tables/UserTransferReceiptList.vue';
import DepositReceiptsRequest from 'App/users/services/DepositReceiptsRequest';

export default {
  name: 'UserDepositReceiptsList',
  extends: UsersTransferReceiptListVue,
  data: () => ({
    requestClass: DepositReceiptsRequest,
  }),
};
</script>
